"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUpdatePaymentProviderFailedResponse = exports.UpdatePaymentProviderFailedEvent = exports.Name = void 0;
var _failedEventData = require("@ori-events/failed-event-data");
const Name = exports.Name = 'update-payment-provider-failed';
const UpdatePaymentProviderFailedEvent = exports.UpdatePaymentProviderFailedEvent = Name;
const isUpdatePaymentProviderFailedResponse = response => (0, _failedEventData.isErrorResponse)(response);
exports.isUpdatePaymentProviderFailedResponse = isUpdatePaymentProviderFailedResponse;
//# sourceMappingURL=index.js.map